import './Languages.scss'

import React from 'react'
import {TranslationsType} from '../../types'
import {useLanguage} from '../../util/i18n'
import {Link} from '../../util/link'
import {style} from '../../util/style'
import {Icon} from '../ui/Icon'

const styles = style('languages')

export type LanguagesType = {
	translations: TranslationsType
}

export const Languages: React.FC<
	LanguagesType & {
		className?: string
	}
> = ({className, translations}) => {
	const currentLang = useLanguage()
	const switchLangs = ['nl', 'fr', 'en']
	if (!translations || Object.keys(translations).length === 0) return null

	return (
		<div className={styles().with(className)}>
			<a className={styles('lang')}>
				<span className={styles('lang-text')}>{currentLang.toUpperCase()}</span>
				<span className={styles('lang-icon')}>
					<Icon icon="chevronDown" />
				</span>
			</a>
			<div className={styles('list')}>
				{switchLangs.map((lang) => {
					if (currentLang === lang) return null
					if (!translations || !translations[lang]) return null
					return (
						<Link
							key={lang}
							to={translations[lang].url || `/${lang}`}
							target="_self"
							className={styles('list-link')}
						>
							{lang.toUpperCase()}
						</Link>
					)
				})}
			</div>
		</div>
	)
}
